import React from 'react';

const IconExternalLink = () => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.8 2.7h3.5v3.5M13.3 2.7 7.6 8.4'
      stroke='currentColor'
      strokeWidth='1.6'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.2 9.6v2.8a1 1 0 0 1-1 1H3.6a1 1 0 0 1-1-1V4.8a1 1 0 0 1 1-1h2.8'
      stroke='currentColor'
      strokeWidth='1.6'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default IconExternalLink;
